import React from "react";
import { cn } from "../../lib/utils.jsx";
import { categories } from "../../data/categories.tsx";
import { useSubscriptions } from "../../hooks/useSubscriptions.tsx";
import { useExchangeRates } from "../../hooks/useExchangeRates.tsx";

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export default function ActiveSubscriptions() {
  const { subscriptions } = useSubscriptions();
  const BASE_CURRENCY = (() => {
    try {
      return localStorage.getItem("pref:baseCurrency") || "AED";
    } catch {
      return "AED";
    }
  })();
  const { rates } = useExchangeRates(BASE_CURRENCY);

  const convertToBase = (amount: number, from: string) => {
    if (!rates) return 0;
    const r: any = rates;
    const base = r[BASE_CURRENCY.toLowerCase()];
    const src = r[(from || "").toLowerCase()];
    if (!base || !src) return 0;
    return amount * (base / src);
  };

  const monthlyTotal = subscriptions
    .filter((s) => s.isActive !== false)
    .reduce((acc, s) => acc + convertToBase(s.amount, s.currency), 0);

  return (
    <div>
      <div className="flex items-baseline justify-between mb-2">
        <div className="text-white/80 text-sm">Active Subscriptions</div>
        <div className="text-white font-semibold">
          {BASE_CURRENCY} {monthlyTotal.toFixed(2)} / mo
        </div>
      </div>
      <div className="widget-scroll">
        {subscriptions
          .filter((s) => s.isActive !== false)
          .map((tx, i) => {
            const categoryType = categories.find(
              (category) => category.id === tx.category
            );

            if (i > 4) {
              return null;
            }

            return (
              <div
                key={tx.id}
                className="flex items-center justify-between py-2"
              >
                <div className="flex items-center gap-3">
                  {/* <div className="p-2 bg-gray-800 rounded-full">
                  {categoryType?.icon ?? "🧾"}
                </div> */}
                  <div>
                    <p className="font-medium">{`${tx.title}`}</p>
                    <p className="text-sm text-gray-500">
                      {categoryType?.name} • {formatDate(tx.startDate)}
                    </p>
                  </div>
                </div>

                <div className="text-right">
                  <p className={cn("font-semibold", "text-gray-300")}>
                    {BASE_CURRENCY}{" "}
                    {convertToBase(tx.amount, tx.currency).toFixed(2)}
                  </p>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
